
















































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

/**
 * Dialog paraf/tanda tangan gores layar (signature pad).
 *
 * Dipakai untuk pihak yang TIDAK punya akun aplikasi (pasien/keluarga),
 * sehingga tidak bisa memakai pola TTD digital berbasis password/PIN
 * (`CardModalTtd`). Hasilnya berupa data URL PNG yang disimpan pemanggil.
 */
@Component
export default class TtdPadDialog extends Vue {
  /** v-model dialog */
  @Prop({ default: false }) readonly value!: boolean;
  @Prop({ default: "Tanda Tangan" }) readonly title!: string;
  /** Nama penanda tangan — hanya ditampilkan sebagai pengingat. */
  @Prop({ default: "" }) readonly nama!: string;
  /** TTD yang sudah ada (data URL) — dimuat agar bisa dilihat/ditimpa. */
  @Prop({ default: "" }) readonly initial!: string;

  @Ref("pad") readonly pad!: HTMLCanvasElement;

  kosong = true;
  private menggambar = false;

  // Ukuran logis kanvas — cukup untuk paraf, sekaligus menjaga ukuran PNG
  // tetap kecil karena hasilnya ikut tersimpan di JSON catatan.
  private readonly lebar = 520;
  private readonly tinggi = 180;

  @Watch("value")
  onToggle(v: boolean) {
    if (!v) return;
    this.$nextTick(() => this.siapkanKanvas());
  }

  siapkanKanvas() {
    const c = this.pad;
    if (!c) return;
    c.width = this.lebar;
    c.height = this.tinggi;

    const ctx = c.getContext("2d");
    if (!ctx) return;
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#000000";

    this.kosong = true;
    this.menggambar = false;

    if (this.initial) {
      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 0, 0, c.width, c.height);
        this.kosong = false;
      };
      img.src = this.initial;
    }
  }

  private titik(e: PointerEvent) {
    const c = this.pad;
    const r = c.getBoundingClientRect();
    // Kanvas ditampilkan responsif (lebar mengikuti dialog) sedangkan ukuran
    // logisnya tetap — koordinat pointer harus diskalakan.
    return {
      x: ((e.clientX - r.left) * c.width) / r.width,
      y: ((e.clientY - r.top) * c.height) / r.height
    };
  }

  mulai(e: PointerEvent) {
    const c = this.pad;
    const ctx = c && c.getContext("2d");
    if (!ctx) return;
    e.preventDefault();
    if (c.setPointerCapture) {
      try {
        c.setPointerCapture(e.pointerId);
      } catch (err) {
        // pointer capture bukan syarat menggambar — abaikan bila ditolak
      }
    }
    const p = this.titik(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    this.menggambar = true;
  }

  gores(e: PointerEvent) {
    if (!this.menggambar) return;
    const ctx = this.pad && this.pad.getContext("2d");
    if (!ctx) return;
    e.preventDefault();
    const p = this.titik(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    this.kosong = false;
  }

  selesai() {
    this.menggambar = false;
  }

  bersihkan() {
    const c = this.pad;
    const ctx = c && c.getContext("2d");
    if (!ctx) return;
    ctx.clearRect(0, 0, c.width, c.height);
    this.kosong = true;
  }

  simpan() {
    if (this.kosong) return;
    this.$emit("save", this.pad.toDataURL("image/png"));
  }

  tutup() {
    this.$emit("input", false);
  }
}
